<svelte:options customElement={{ tag: "bt-search-results-loader", shadow: "none" }} />

<script lang="ts">
	import { createTimeline, spring, cubicBezier } from 'animejs';
	export let frameId = '';
	export let animationId: string = '';

	let loadingFinished = false;
	let loadingEvent;

	/* Normally in Svelte 4 we'd want to be just binding this to the
	svelte:document object, i.e. on:mouseenter={handleMouseEnter}. but the Turbo event syntax is *weird* and gets in the way -- on:turbo:before-frame-render doesn't work, nor does on:turbobeforeframerender */
	function documentLoaded(doc: any) {

		let allAnimationContainers = Array.from(doc.querySelectorAll('.ai-loader'));
		let thisAnimationContainer = allAnimationContainers.find(el => {
			return el.dataset.animationid === animationId
		})

		let cube = thisAnimationContainer.getElementsByClassName('ai-loader__cube')[0];
		let squareVertical = thisAnimationContainer.querySelector('.ai-loader__cube__plus--square--vertical');
		let squareHorizontal = thisAnimationContainer.querySelector('.ai-loader__cube__plus--square--horizontal');
		let squareInner = thisAnimationContainer.querySelector('.ai-loader__cube__plus--square--inner');

		let cubeToFrontTimeline, frontToCubeTimeline, squarePlusTimeline;

		cubeToFrontTimeline = createTimeline({
			loop: false,
			autoplay: true,
			onComplete: () => {
				// After cube moves to top, fire the animation where the square becomes a plus
				squarePlusTimeline.play()
			}
		})
		squarePlusTimeline = createTimeline({
			loop: Infinity,
			loopDelay: 500,
			autoplay: false,
			playbackEase: "inOut",
			onLoop: (thisTimeline) => {
				if (loadingFinished && loadingEvent) {
					// At the end of the loop, if Turbo is ready to load stuff in,
					thisTimeline.pause();
					frontToCubeTimeline.play();
				}
			}
		})
		frontToCubeTimeline = createTimeline({
			loop: false,
			autoplay: false,
			onComplete: () => {
				loadingEvent.detail.resume(); // Let Turbo continue loading
			}
		})

		cubeToFrontTimeline.set(cube, {
			transateZ: 100,
			rotateX: "-30deg",
			rotateY: "45deg"
		}, 0)
		cubeToFrontTimeline.add(cube, {
			rotateX: "-90deg",
			rotateY: "0deg",
			duration: 490,
			ease: cubicBezier(0.152,0.539,0.822,0.545)
		})
		cubeToFrontTimeline.add(cube, {
			rotateX: "-90deg",
			rotateY: "0deg",
			duration: 240
		}, 490)


		frontToCubeTimeline.set(cube, {
			rotateX: "-90deg",
			rotateY: "0deg",
			duration: 500
		}, 500)
		frontToCubeTimeline.add(cube, {
			rotateX: "-30deg",
			rotateY: "45deg",
			duration: 500,
			ease: cubicBezier(0.396,0.119,0.656,0.848)
		}, 500)
		frontToCubeTimeline.add(cube, {
			rotateX: "-30deg",
			rotateY: "45deg",
			duration: 100,
		}, 1000)

		squarePlusTimeline.set(squareVertical, {
			backgroundColor: "#000000", scale: 1, borderRadius: "0px"
		})
		squarePlusTimeline.set(squareHorizontal, {
			backgroundColor: "#000000", scale: 1, borderRadius: "0px"
		})
		squarePlusTimeline.set(squareInner, {
			backgroundColor: "#FFFFFF", scale: 1
		})
		squarePlusTimeline.add(squareVertical, {
			borderRadius: "5px",
			duration: 100
		}, 0)
		squarePlusTimeline.add(squareHorizontal, {
			borderRadius: "5px",
			duration: 100
		}, 0)
		squarePlusTimeline.add(squareVertical, {
			scale: .25,
			duration: 300
		}, 0)
		squarePlusTimeline.add(squareHorizontal, {
			scale: .25,
			duration: 300
		}, 0)
		squarePlusTimeline.add(squareInner, {
			scale: 0,
			duration: 300
		}, 0)
		squarePlusTimeline.set(squareHorizontal, {
			borderRadius: "0px",
		}, 300)
		squarePlusTimeline.set(squareVertical, {
			borderRadius: "0px",
		}, 300)
		squarePlusTimeline.add(squareVertical, {
			scaleX: 3,
			scaleY: .75,
			ease: spring({
		    bounce: 0.5,
		    duration: 250
		  })
		}, 500)
		squarePlusTimeline.add(squareHorizontal, {
			scaleY: 3,
			scaleX: .75,
			ease: spring({
		    bounce: 0.5,
		    duration: 250
		  })
		}, 500)
		squarePlusTimeline.add(squareVertical, {
			scaleX: 1,
			scaleY: 1,
			duration: 250
		}, 1250)
		squarePlusTimeline.add(squareHorizontal, {
			scaleY: 1,
			scaleX: 1,
			duration: 250
		}, 1250)
		squarePlusTimeline.add(squareVertical, {
			scale: 1,
			ease: spring({
		    bounce: 0.4,
		    duration: 500
		  })
		}, 1750)
		squarePlusTimeline.add(squareHorizontal, {
			scaleY: 1,
			ease: spring({
		    bounce: 0.4,
		    duration: 500
		  })
		}, 1750)
		squarePlusTimeline.add(squareInner, {
			scale: 1,
			duration: 500,
			ease: spring({
		    bounce: 0.4,
		    duration: 500
		  })
		}, 1750)

		doc.addEventListener('turbo:before-frame-render', async(event: any) => {
			if (event?.target?.id === frameId) {
				loadingEvent = event;
				event.preventDefault(); // Pauses Turbo from loading new frame
				loadingFinished = true;
			}
		});
	}
</script>

<svelte:document use:documentLoaded />
